<template>
    <section class="mod">
        <!-- <h2 class="mod-tit">
            历史北向数据<router-link class="fr link-more" :to="'/historylist'"
                >查看更多</router-link
            >
        </h2> -->
        <h2 class="mod-tit">
            历史明细
            <router-link class="fr link-more-btn" :to="'/historylist'" >&ensp;更多</router-link>
        </h2>


        <div class="table-scroll" >
            <div class="table-l fl">
                <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                        <th>日期</th>
                    </tr>
                    <tr
                        v-for="(item,index) in dataInfo.slice(0, 10)"
                        :key="index"
                    >
                        <td>{{ item.shTradeTime.slice(0,4)+'-'+item.shTradeTime.slice(4,6)+'-'+item.shTradeTime.slice(6,8) }}</td>
                    </tr>
                </table>
            </div>
            <div class="table-r">
                <div class="table-r-wrap">
                    <table width="100%" cellspacing="0" cellpadding="0">
                        <tr>
                            <th>成交总额<br /> (沪股通)</th>
                            <th>成交总额<br /> (深股通)</th>
                            <th>合计</th>
                        </tr>
                        <tr
                            v-for="(item,index) in dataInfo.slice(0, 10)"
                            :key="index"
                        >
                            <td :class="item.shTodayTotalAmount | formateRedGreen">
                                {{ item.shTodayTotalAmount | formateMillionYi}}
                            </td>
                            <td :class="item.szTodayTotalAmount | formateRedGreen">
                                {{ item.szTodayTotalAmount | formateMillionYi}}
                            </td>
                            <td :class="item.shsztotal | formateRedGreen">
                                {{ item.shsztotal | formateMillionYi}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
// 获取历史北向数据
import { bxzjCjzelsmx } from "@/api/lszx.js";
import { bxzjLsmx } from "@/api/lszx.js";

export default {
    name: "HistoryNorthData",
    data() {
        return {
            ZJTodayNavs: [ '成交净买额',"成交总额"],
            curZJToday: 0,

            dataInfo:[],
            dataInfoJlr:[],
        };
    },
    filters: {
        formateMillionYi:function(v){
            if (v == undefined || v == null) return;
            return (v / 100).toFixed(2)+ '亿'
        },
        formateTag: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "交易中";
            if (v < 0) return "已结束";
        },
        formatePrefixData: function (v) {
            if (v == undefined || v == null) return "--";
            if (v > 0) return "+" + v;
            if (v < 0) return v;
        },
        formateRedGreen: function (v) {
            if (v == undefined || v == null) return;
            if (v > 0) return "ft-red";
            if (v < 0) return "ft-green";
        },
    },
    mounted: function () {
        this.getLssj();
        this.getLssjJlr();
    },
    methods: {
        setCav:function(i){
            this.curZJToday = i
            // if(i == 0){
            //     this.getLssj()
            // }else{
            //     this.getLssjJlr()
            // }
        },
        getLssj: function () {
            var _this = this;
            var params = {
                'start':'-10',
                'count':'10',
            }
            bxzjCjzelsmx(params).then((res) => {

                if (res.data.err == 0) {
                    _this.dataInfo = res.data.data.list.reverse();
                } else {
                    _this.dataInfo = [];
                }
            });
        },
        getLssjJlr: function () {
            var _this = this;
            var params = {
                'start':'-10',
                'count':'10',
            }
            bxzjLsmx(params).then((res) => {
                if (res.data.err == 0 && res.data.data.list != undefined && res.data.data.list.length > 0) {
                    _this.dataInfoJlr = res.data.data.list.slice(0, 10);
                } else {
                    _this.dataInfoJlr = [];
                }
            });
        },
    },
};
</script>
